import { IMultiSportEventResponse, SDKDateOptions } from '../../../../packages/types';
import { LinkCreationService, getMatchDate, getNameByStatus, getEventStatus } from '@sportal365/smp-widget-utils';
import { LIVE, NOT_STARTED } from '../../../../packages/constants/statusTypes';
import moment from 'moment-mini';
import { assetsPlaceholder } from '../../../../packages/constants/assetsPlaceholder';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';
import { TEAM_ENTITY } from '../../../../packages/constants/entityTypes';
import { IMultiSportConfig, ResultTypes } from '../../../../packages/types/multisport';

interface INormalizeEvent {
  game?: IMultiSportEventResponse;
  sdkOptions: SDKDateOptions;
  dataShortStatusType: IMultiSportConfig['dataShortStatusType'];
  dataTeamNameType: IMultiSportConfig['dataTeamNameType'];
  dataEntityLinks: IMultiSportConfig['dataEntityLinks'];
}

export const normalizeEventResponseData = ({
  game,
  sdkOptions,
  dataShortStatusType,
  dataTeamNameType,
  dataEntityLinks,
}: INormalizeEvent) => {
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  if (!game || !game.competition || !game.participant_details.length) return;

  const competitionUrl = linkService?.createEntityUrl(game.competition.id || '', 'competition', '', game.competition.slug) ?? '#';
  const matchLink =
    linkService?.createMatchUrl(game.id, game.participant_details[0].participant, game.participant_details[1].participant, game.slug) ??
    '#';

  return {
    competition: {
      id: game.competition.id,
      name: game.competition.name,
      date: getMatchDate(game.start_time, sdkOptions),
      url: competitionUrl,
      round: game.round?.name,
    },
    firstTeam: {
      id: game.participant_details[0].participant.id,
      name: getNameByStatus({ ...game.participant_details[0].participant, status: dataTeamNameType }),
      logo: game.participant_details[0].participant.display_asset.url || assetsPlaceholder.team,
      url:
        linkService?.createEntityUrl(
          String(game.participant_details[0].participant.id),
          TEAM_ENTITY,
          '',
          game.participant_details[0].participant.slug,
        ) ?? '#',
      isWinner: game.participant_details[0].participant.winner === 'YES' ? true : false,
      score: game.participant_details[0].results?.find(({ type }) => type.code === ResultTypes.FINAL_RESULT)?.value ?? '',
      penaltyScore: game.participant_details[0].results?.find(({ type }) => type.code === ResultTypes.PENALTY_SHOOTOUT)?.value ?? '',
    },
    secondTeam: {
      id: game.participant_details[1].participant.id,
      name: getNameByStatus({ ...game.participant_details[1].participant, status: dataTeamNameType }),
      logo: game.participant_details[1].participant.display_asset.url || assetsPlaceholder.team,
      url:
        linkService?.createEntityUrl(
          String(game.participant_details[1].participant.id),
          TEAM_ENTITY,
          '',
          game.participant_details[1].participant.slug,
        ) ?? '#',
      isWinner: game.participant_details[1].participant.winner === 'YES' ? true : false,
      score: game.participant_details[1].results?.find(({ type }) => type.code === ResultTypes.FINAL_RESULT)?.value ?? '',
      penaltyScore: game.participant_details[1].results?.find(({ type }) => type.code === ResultTypes.PENALTY_SHOOTOUT)?.value ?? '',
    },
    id: game.id,
    url: matchLink,
    status: getEventStatus({
      type: game.status_type,
      status: game.status,
      participants: game.participant_details,
      minute: game.elapsed,
      statusType: dataShortStatusType,
    }),
    isLive: game.status_type === LIVE,
    isStarted: game.status_type === NOT_STARTED ? false : true,
    startTime: moment(game.start_time).format('HH:mm'),
    odds: game.odds,
    target: target,
  };
};
